import { InjectionKey, Ref } from 'vue';

interface AppProvide {
    gmapsApiKey: Ref<string>;
}

export const AppProvideKey: InjectionKey<AppProvide> = Symbol.for('webshop:app');
